/**
 * Meta Pixel event tracking helpers.
 *
 * The base pixel snippet lives in /public/index.html and fires `PageView`
 * automatically. Everything below is for funnel-specific events that Meta's
 * ad optimizer uses to find buyers:
 *
 *   InitiateCheckout — someone tapped the $7 trial CTA on /join
 *   Purchase         — someone completed a paid Stripe checkout ($7 trial or $97 OTO)
 *
 * We guard every call with `typeof window.fbq === "function"` so nothing throws
 * if the pixel didn't load (ad-blockers, no-JS previews, unit tests, SSR).
 * Fire-and-forget — Meta accepts every event async, no promise chain needed.
 */

function pixel(...args) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq(...args);
    }
  } catch { /* never crash the app because a pixel event failed */ }
}

/** Fired when a visitor taps the $7 Start Trial CTA on /join. */
export function trackInitiateCheckout() {
  pixel("track", "InitiateCheckout", {
    value: 7.00,
    currency: "AUD",
    content_name: "$7 first-week trial",
    content_category: "funnel",
  });
}

/** Fired after the $7 first-week trial is paid — landing on /join/upgrade. */
export function trackTrialPurchase() {
  pixel("track", "Purchase", {
    value: 7.00,
    currency: "AUD",
    content_name: "$7 first-week trial",
    content_category: "funnel",
    content_ids: ["trial-7-dollar"],
  });
}

/** Fired after the $97 Roadmap Call OTO is paid — landing on /join/book-call. */
export function trackOTOPurchase() {
  pixel("track", "Purchase", {
    value: 97.00,
    currency: "AUD",
    content_name: "Lean Roadmap Call",
    content_category: "funnel-oto",
    content_ids: ["roadmap-call"],
  });
}
